import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'

import { BookingMultiDayForm } from 'src/app/shared/models'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { environment } from 'src/environments/environment'
import { productSelectors } from '../../../product/product.selectors'
import { AppState } from '../../../../core/core.state'
import { Store } from '@ngrx/store'
import { tagSelectors } from '../../../tag/tag.selectors'
import { Product } from '../../../product/product'
import { ConfigurationService } from '../../../../shared/services/configuration.service'
import { Tag } from '../../../tag/tag'
import { Dictionary } from '@ngrx/entity'
import { BookingMultiDayService } from '../booking-multi-day.service'
import { markFormGroupDirty } from '../../../../shared/utils/mark-form-dirty'
import { bookingSelectors } from '../../../booking/booking.selectors'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Booking } from 'src/app/features/booking/booking'
import { filter, take, tap, delay, withLatestFrom } from 'rxjs/operators'
import { combineLatest, Observable } from 'rxjs'
import { translationSelectors } from 'src/app/features/translation/translation.selectors'
import { Translation } from 'src/app/features/translation/translation'
import { OnChanges, ChangeDetectorRef } from '@angular/core'
import { formatDate } from '@angular/common'
import { ParticipationService } from 'src/app/features/booking/participation/participation.service'
import { NotificationService } from '../../../../core/notification.service'
import { TranslateService } from '@ngx-translate/core'
import { bookingActions } from 'src/app/features/booking/booking.actions'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'

@UntilDestroy()
@Component({
  selector: 'step-03-facilities-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './step03-facilities-form.component.html',
  styleUrls: ['./step03-facilities-form.component.scss']
})
export class Step03FacilitiesFormComponent implements OnInit, OnChanges {
  @Input() datesList: Moment[]

  @Input() products: Partial<Product>[]

  @Output() onSubmit = new EventEmitter<any>()

  @Input() bookingFacilities: any

  @Input() booking: BookingMultiDayForm

  public form: UntypedFormGroup = this.fb.group({
    dates: new UntypedFormArray([])
  })
  public bookedProductDuringStay = new Map<string, boolean>()
  public bookedProductDuringStayWithDate: any[] = []
  public totalHiddenProducts = new Map<string, any[]>()
  public selectedDate: Moment
  public selectedDateIndex: number = 0

  public staticAssetBaseUrl: any = environment.staticAssetBaseUrl

  public productEntities$: Observable<Dictionary<Product>> = this.store.select(
    productSelectors.selectEntities
  )
  public tagsEntities$: Observable<Dictionary<Tag>> = this.store.select(
    tagSelectors.selectEntities
  )
  public translations: Dictionary<Translation>

  public translations$: Observable<Dictionary<Translation>> = this.store.select(
    translationSelectors.selectEntities
  )

  public isBuildingForm: any = true

  constructor(
    private fb: UntypedFormBuilder,
    private chd: ChangeDetectorRef,
    private translate: TranslateService,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    public configurationService: ConfigurationService,
    public bookingMultiDayService: BookingMultiDayService,
    public participationService: ParticipationService
  ) {}

  public get datesForm(): UntypedFormArray {
    return this.form?.get('dates') as UntypedFormArray
  }

  public getDatesForm(selectedDate: Moment): UntypedFormGroup {
    let formGroup: UntypedFormGroup
    this.datesForm.controls.forEach((control: UntypedFormGroup) => {
      if (control.value['date'] === selectedDate?.format?.()) {
        formGroup = control
      }
    })
    return formGroup
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.products &&
      JSON.stringify(changes.products?.currentValue) !==
        JSON.stringify(changes.products?.previousValue)
    ) {
      this.products = changes.products.currentValue
      console.log('selected products for the step ', this.products)
    }
  }
  ngOnInit(): void {
    // set first date as selected
    this.selectedDate = this.datesList[0]
    this.form = this.fb.group({
      dates: new UntypedFormArray([])
    })
    this.translations$
      .pipe(take(1))
      .subscribe((trans: Dictionary<Translation>) => {
        this.translations = trans
      })

    // create a form group for each date based on product
    combineLatest([
      this.store.select(bookingSelectors.selectAll),
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectIsLoading)
    ])
      .pipe(
        filter(
          ([, productEntities, bookingsAreLoading]) =>
            !bookingsAreLoading &&
            this.hasRequiredProductsLoaded(productEntities)
        ),
        take(1)
      )
      .subscribe(([bookings, productEntities]) => {
        this.datesList.forEach((date) => {
          this.addDatesForm(date, bookings, productEntities)
        })
        this.isBuildingForm = false
        this.chd.detectChanges()
      })
  }
  getMaxParticipants(booking, poductMaxParticipants, productFb) {
    return productFb.controls['maxParticipants']?.value['maxParticipants'] || ''
  }
  onSubmitFormValues(): void {
    if (this.booking.details.participants.numberSleepOver) {
      let f = this.form
      this.productEntities$.pipe(take(1)).subscribe((productEntities) => {
        f.setErrors(null)
        let haveQtyErrors: boolean = false
        f.controls['dates'].value.map((item) => {
          let totalPartcipants: number = 0
          haveQtyErrors = false
          item.products?.map((product) => {
            if (product.selected) {
              totalPartcipants = totalPartcipants + product['qty']
            }

            if (
              // product['qty'] >
              // this.booking.details.participants.numberSleepOver ||
              // totalPartcipants >
              //   this.booking.details.participants.numberSleepOver ||
              product['qty'] >
                this.participationService.calculateParticipantLimits(
                  productEntities[product['bookableProductId']],
                  null,
                  productEntities[product['productId']].maxParticipants
                ).maxParticipants &&
              !haveQtyErrors &&
              product.selected
            ) {
              this.showModal(item)
              f.setErrors({ qtyError: 'true' })
              haveQtyErrors = true
            }
          })
        })
        if (this.form.invalid || f.invalid) {
          markFormGroupDirty(this.form)
          return
        }

        this.onSubmit.emit({
          dates: this.lessOneMinuteCheckOut(this.form.value)
        })
      })
    } else {
      if (this.form.invalid) {
        markFormGroupDirty(this.form)
        return
      }

      this.onSubmit.emit({
        dates: this.lessOneMinuteCheckOut(this.form.value)
      })
    }
  }
  private showModal(item) {
    this.translate
      .get('general.errorMaxParticipants')
      .pipe(take(1))
      .subscribe((msg) => {
        this.notificationService.emit(
          `${msg} ${moment(item.date).format('DD-MM-YYYY')}
         `,
          'warning'
        )
      })
  }
  private lessOneMinuteCheckOut(formValues) {
    return formValues.dates.map((values) => {
      if (values.products) {
        values.products.map((product) => {
          if (product.selected) {
            product.checkOut = moment(product.checkOut).subtract(1, 'm')
          }
        })
      }
      return values
    })
  }
  public copyFromLastDay(dateIndex: number): void {
    const lastDay: number = dateIndex - 1
    if (lastDay >= 0) {
      const currentValue: any = this.getDatesForm(
        this.datesList[dateIndex]
      ).value
      const previousDayFormValue: any = this.getDatesForm(
        this.datesList[lastDay]
      ).value

      this.getDatesForm(this.datesList[dateIndex]).setValue({
        ...previousDayFormValue,
        date: currentValue.date
      })
    }
  }

  wholeStayStatus: boolean = false
  setForWholeStay(dateIndex: number): void {
    this.wholeStayStatus = !this.wholeStayStatus
    if (this.wholeStayStatus) {
      const formValue: any = this.getDatesForm(this.datesList[dateIndex]).value

      this.datesList.forEach((date, index) => {
        if (dateIndex !== index) {
          let selectedDateForm: UntypedFormGroup = this.getDatesForm(
            this.datesList[index]
          )
          let products: UntypedFormArray = new UntypedFormArray([])

          selectedDateForm.value['products'].map((item) => {
            const itemSearched = formValue['products'].filter(
              (fv) =>
                fv.productId == item.productId &&
                fv.bookableProductId == item.bookableProductId
            )

            if (itemSearched.length > 0) {
              item.checkIn = itemSearched[0].checkIn
              item.checkOut = itemSearched[0].checkOut
              item.qty = itemSearched[0].qty
              item.selected = itemSearched[0].selected
              item.option = itemSearched[0].option
            }
            products.controls.push(item)
          })
          selectedDateForm.setValue({
            date: date.format(),
            products: products.controls
          })
          // selectedDateForm.setValue({
          //   ...formValue,
          //   date: date.format()
          // })
        }
      })
    }
  }

  getTagByLevel(
    tags: number[],
    tagsEntities: Dictionary<Tag> | null,
    level: number
  ): Tag[] {
    if (tags?.length > 0) {
      return tags
        ?.map((tId) => tagsEntities?.[tId])
        .filter((t) => t?.level === level)
    }

    return []
  }

  public addDateBefore(): void {
    const firstDate: Moment = moment(this.datesList[0])
    firstDate.subtract(1, 'days')
    this.datesList.unshift(firstDate)

    combineLatest([
      this.store.select(bookingSelectors.selectAll),
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectIsLoading)
    ])
      .pipe(
        filter(
          ([, productEntities, bookingsAreLoading]) =>
            !bookingsAreLoading &&
            this.hasRequiredProductsLoaded(productEntities)
        ),
        take(1)
      )
      .subscribe(([bookings, productEntities]) => {
        this.addDatesForm(firstDate, bookings, productEntities)
      })

    this.selectedDate = this.datesList[0]
  }

  public addDateAfter(): void {
    const lastDate: Moment = moment(this.datesList[this.datesList.length - 1])
    lastDate.add(1, 'days')
    this.datesList.push(lastDate)

    combineLatest([
      this.store.select(bookingSelectors.selectAll),
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectIsLoading)
    ])
      .pipe(
        filter(
          ([, productEntities, bookingsAreLoading]) =>
            !bookingsAreLoading &&
            this.hasRequiredProductsLoaded(productEntities)
        ),
        take(1)
      )
      .subscribe(([bookings, productEntities]) => {
        this.addDatesForm(lastDate, bookings, productEntities)
      })

    this.selectedDate = this.datesList[this.datesList.length - 1]
  }

  public removeDate(dateIndex: number): void {
    const selectedDate: any = this.datesList[dateIndex]
    this.datesList.splice(dateIndex, 1)
    this.removeDatesFormByDate(selectedDate)
    this.selectedDate = this.datesList[0]
  }

  public removeDatesFormByDate(selectedDate: Moment): void {
    this.datesForm.controls.forEach(
      (control: UntypedFormGroup, index: number) => {
        if (control.value['date'] === selectedDate?.format?.()) {
          this.datesForm.removeAt(index)
        }
      }
    )
  }

  private hasRequiredProductsLoaded(
    productEntities: Dictionary<Product>
  ): boolean {
    if (!this.products?.length) {
      return false
    }

    return this.products.every((product) => {
      if (!product?.id || !productEntities?.[product.id]) {
        return false
      }

      if (!product.parentBookableProducts?.length) {
        return true
      }

      return product.parentBookableProducts.every(
        (parentProductId) => !!productEntities?.[parentProductId]
      )
    })
  }
  public getFormatDate(productId) {
    const filteredProducts = this.bookedProductDuringStayWithDate.filter(
      (bk) => bk.productId === productId
    )
    let formatDate = ''
    filteredProducts.map(
      (fp) =>
        (formatDate = formatDate + ',' + moment(fp.date).format('DD-MM-YYYY'))
    )
    return formatDate
  }
  public getSelectedProductIdDescription(
    productId: number,
    productEntities: Dictionary<Product>
  ) {
    return productEntities[productId].description
  }
  public getSelectedDependantProductId(
    productId: number,
    productEntities: Dictionary<Product>,
    productForm: UntypedFormGroup
  ): number {
    const dependantProducts: any = productEntities[productId].dependantProducts

    if (!dependantProducts || dependantProducts.length === 0 || !productForm) {
      return null
    }

    const selectedProducts: number[] = productForm.value?.products
      ?.filter((p) => p.selected)
      ?.map((p) => p.bookableProductId)

    if (!selectedProducts || selectedProducts.length === 0) {
      return null
    }

    const dependantProductId = dependantProducts.find((p) =>
      selectedProducts.includes(p)
    )

    if (!dependantProductId) {
      return null
    }

    return dependantProductId
  }

  public disabledMinutes(hour: number): number[] {
    return hour === 23 ? Array.from({ length: 59 }, (_, i) => i + 1) : []
  }
  public disabledAllHours(hour: number): number[] {
    return Array.from(Array(24).keys())
  }

  public disabledAllMinutes(hour: number): number[] {
    return Array.from(Array(60).keys())
  }
  private getDefaultCheckTime(productActivity) {
    let defaultCheckInTime
    let defaultCheckOutTime

    if (
      productActivity.defaultStartTime &&
      typeof productActivity.defaultStartTime == 'string' &&
      !moment(productActivity.defaultStartTime).isValid()
    ) {
      defaultCheckInTime = productActivity.defaultStartTime
        ? moment(
            '2020-01-01 ' + productActivity.defaultStartTime,
            'YYYY-MM-DD HH:mm'
          )
        : moment('2020-01-01 00:00:00', 'YYYY-MM-DD HH:mm')
    } else if (
      productActivity.defaultStartTime &&
      moment(productActivity.defaultStartTime).isValid()
    ) {
      defaultCheckInTime = productActivity.defaultStartTime
        ? moment(
            String(
              '2020-01-01 ' +
                moment(productActivity.defaultStartTime).format('HH:mm')
            ),
            'YYYY-MM-DD HH:mm'
          )
        : moment('2020-01-01 00:00:00', 'YYYY-MM-DD HH:mm')
    } else {
      defaultCheckInTime = moment('2020-01-01 00:00:00', 'YYYY-MM-DD HH:mm')
    }
    if (
      productActivity.defaultEndTime &&
      typeof productActivity.defaultEndTime == 'string' &&
      !moment(productActivity.defaultEndTime).isValid()
    ) {
      defaultCheckOutTime = productActivity.defaultEndTime
        ? moment(
            '2020-01-01 ' + productActivity.defaultEndTime,
            'YYYY-MM-DD HH:mm'
          )
        : moment('2020-01-01 23:59:00', 'YYYY-MM-DD HH:mm')
    } else if (
      productActivity.defaultEndTime &&
      moment(productActivity.defaultEndTime).isValid()
    ) {
      defaultCheckOutTime = productActivity.defaultEndTime
        ? moment(
            String(
              '2020-01-01 ' +
                moment(productActivity.defaultEndTime).format('HH:mm')
            ),
            'YYYY-MM-DD HH:mm'
          )
        : productActivity.slotMinutes && productActivity.defaultStartTime
          ? moment(
              String(
                '2020-01-01 ' +
                  moment(productActivity.defaultStartTime).format('HH:mm')
              ),
              'YYYY-MM-DD HH:mm'
            ).add(productActivity.slotMinutes, 'minutes')
          : moment('2020-01-01 23:59:00', 'YYYY-MM-DD HH:mm')
    } else {
      defaultCheckOutTime = moment('2020-01-01 23:59:00', 'YYYY-MM-DD HH:mm')
    }

    return { defaultCheckInTime, defaultCheckOutTime }
  }
  private getBookingConflicts(
    selectedDate,
    bookings,
    productEntities,
    productBookedHours
  ) {
    let mappedBookings = JSON.parse(JSON.stringify(bookings))
    mappedBookings.map((bk: Booking) => {
      if (bk.startDate) {
        bk.startDate = moment(bk.startDate)
          .set('second', 0)
          .set('millisecond', 0)
          .toISOString()
      }
      if (bk.endDate) {
        bk.endDate = moment(bk.endDate)
          .set('second', 0)
          .set('millisecond', 0)
          .toISOString()
      }
    })
    bookings = mappedBookings

    for (const productActivity of this.products) {
      if (productActivity?.parentBookableProducts) {
        for (const productResourceId of productActivity?.parentBookableProducts) {
          // requirements to list resources
          // 1. get booked hours for each productResource for the selected date.
          // 2. check if the productResource has a dependency on another productResource.
          // 3. mark the resource as booked for the same hours as the product.
          // 4. hide the product or its resources if they are booked for whole day.

          // for example:
          // A16-FullRoom has a dependency on A17 and A18
          // A16 is booked for 13-17 => A17 is booked for 13-17 and A18 is booked for 13-17

          // we need to have a list of booked hours for each productResource on each date.
          // we use the productBookedHours map to store this list.
          // the product key is the productResourceId + the date.
          const bookableProduct = productEntities[productResourceId]
          const productKey = `${productResourceId}-${selectedDate.format()}`

          const productBookingsAtDate = bookings.filter(
            (booking) =>
              (booking.productId === productResourceId ||
                bookableProduct.dependantProducts.includes(
                  booking.productId
                )) &&
              selectedDate.isSameOrAfter(moment(booking.startDate), 'day') &&
              selectedDate.isSameOrBefore(moment(booking.endDate), 'day')
          )
          // get all hours that are booked for this product on this date
          const bookedHours = productBookingsAtDate.reduce((acc, booking) => {
            // get hours from start to end using moment
            const hours = Array.from(
              {
                length:
                  moment(booking.endDate).diff(
                    moment(booking.startDate),
                    'hours'
                  ) + 1
              },
              (_, i) => i + moment(booking.startDate).hours()
            )
            return [...acc, ...hours]
          }, [])

          if (bookedHours.length > 0) {
            this.bookedProductDuringStay.set(productKey, true)
            productBookedHours.set(productKey, [
              ...new Set([
                ...bookedHours,
                ...(productBookedHours.get(productKey) ?? [])
              ])
            ])
            const filteredProducts =
              this.bookedProductDuringStayWithDate.filter(
                (bk) => bk.productId === productResourceId
              )
            if (filteredProducts.length === 0) {
              this.bookedProductDuringStayWithDate.push({
                productId: productResourceId,
                date: selectedDate,
                booking: productBookingsAtDate
              })
            } else {
              let isPushed = false
              filteredProducts.map((fp) => {
                if (
                  moment(fp.date).format('DD-MM-YYYY') ===
                  moment(selectedDate).format('DD-MM-YYYY')
                ) {
                  isPushed = true
                }
              })
              if (!isPushed) {
                this.bookedProductDuringStayWithDate.push({
                  productId: productResourceId,
                  date: selectedDate,
                  booking: productBookingsAtDate
                })
              }
            }
            if (
              bookableProduct.dependantProducts &&
              bookableProduct.dependantProducts.length > 0
            ) {
              let totalDependantBlocked = 0
              for (const dependantProductId of bookableProduct.dependantProducts) {
                const subDpKey = `${dependantProductId}-${selectedDate.format()}`
                if (this.bookedProductDuringStay.get(subDpKey)) {
                  totalDependantBlocked += 1
                }
                //  this.bookedProductDuringStay.set(dependantProductId, true)
                // const filteredProducts =
                //   this.bookedProductDuringStayWithDate.filter(
                //     (bk) => bk.productId === dependantProductId
                //   )
                // if (filteredProducts.length === 0) {
                //   this.bookedProductDuringStayWithDate.push({
                //     productId: dependantProductId,
                //     date: selectedDate,
                //     booking: productBookingsAtDate
                //   })
                // } else {
                //   let isPushed = false
                //   filteredProducts.map((fp) => {
                //     if (
                //       moment(fp.date).format('DD-MM-YYYY') ===
                //       moment(selectedDate).format('DD-MM-YYYY')
                //     ) {
                //       isPushed = true
                //     }
                //   })
                //   if (!isPushed) {
                //     this.bookedProductDuringStayWithDate.push({
                //       productId: dependantProductId,
                //       date: selectedDate,
                //       booking: productBookingsAtDate
                //     })

                //     if (!this.bookedProductDuringStay.get(productKey)) {
                //       this.bookedProductDuringStay.set(productKey, true)
                //     }
                //   }
                // }

                // const dependantProductKey = `${dependantProductId}-${selectedDate.format()}`
                // productBookedHours.set(dependantProductKey, [
                //   ...bookedHours,
                //   ...(productBookedHours.get(dependantProductKey) ?? [])
                // ])
              }
              if (
                totalDependantBlocked > 0 &&
                !this.bookedProductDuringStay.get(
                  `${bookableProduct.id}-${selectedDate.format()}`
                )
              ) {
                this.bookedProductDuringStay.set(
                  `${bookableProduct.id}-${selectedDate.format()}`,
                  true
                )
              }
            }
          } else {
            let totalDependantBlocked = 0
            for (const subDependantProductId of productEntities[
              productResourceId
            ].dependantProducts) {
              const subDpKey = `${subDependantProductId}-${selectedDate.format()}`
              if (this.bookedProductDuringStay.get(subDpKey)) {
                totalDependantBlocked += 1
              }
            }
            if (
              totalDependantBlocked > 0 &&
              !this.bookedProductDuringStay.get(productKey)
            ) {
              this.bookedProductDuringStay.set(productKey, true)
            }
          }
        }
      }
    }
    return productBookedHours
  }

  private checkIfProductShouldHidden(
    productActivity,
    productEntities,
    selectedDate,
    defaultHours,
    productBookedHours,
    hiddenProducts
  ) {
    for (const productResourceId of productActivity?.parentBookableProducts) {
      const bookableProduct: Product = productEntities[productResourceId]
      const productKey = `${productResourceId}-${selectedDate.format()}`

      // if every default hour is booked, hide the product or onlineAvailable/available start not is after selectedDate
      const shouldHideProduct =
        defaultHours.every((hour) =>
          (productBookedHours.get(productKey) ?? []).includes(hour)
        ) || this.checkIfshouldBeHIddenInThisDate(bookableProduct, selectedDate)

      if (shouldHideProduct) {
        const dependantProducts = bookableProduct.dependantProducts
        hiddenProducts.set(productResourceId, true)
        if (dependantProducts?.length) {
          for (const dependantProductId of dependantProducts) {
            if (
              !productActivity?.parentBookableProducts.includes(
                dependantProductId
              )
            )
              hiddenProducts.set(dependantProductId, true)
          }
        }
      }
    }

    if (hiddenProducts.size > 0) {
      console.log(
        `hidden products for ${
          productActivity.description
        } on ${selectedDate.format()}`,
        Array.from(hiddenProducts.entries())?.map(([id]: any) => id)
      )

      if (
        this.totalHiddenProducts.get(
          `${productActivity.id}-${selectedDate.format('YYYY-MM-DD')}`
        )?.length > 0
      ) {
        const arrayProduct = this.totalHiddenProducts.get(
          `${productActivity.id}-${selectedDate.format('YYYY-MM-DD')}`
        )
        Array.from(hiddenProducts.entries())?.map(([id]: any) =>
          arrayProduct.push(id)
        )
        this.totalHiddenProducts.set(
          `${productActivity.id}-${selectedDate.format('YYYY-MM-DD')}`,
          [...new Set(arrayProduct)]
        )
      } else {
        this.totalHiddenProducts.set(
          `${productActivity.id}-${selectedDate.format('YYYY-MM-DD')}`,
          Array.from(hiddenProducts.entries())?.map(([id]: any) => id)
        )
      }
    }
    return hiddenProducts
  }
  private addDatesForm(
    selectedDate: Moment,
    bookings: Booking[],
    productEntities: Dictionary<Product>
  ) {
    const fg = this.fb.group({
      date: [selectedDate.format()],
      products: new UntypedFormArray([])
    })
    const defaultDisabledHours = Array.from(Array(24).keys())
    const productsFormArray = fg.get('products') as UntypedFormArray
    let productBookedHours = new Map<string, number[]>()

    productBookedHours = this.getBookingConflicts(
      selectedDate,
      bookings,
      productEntities,
      productBookedHours
    )

    for (const productActivity of this.products) {
      let hiddenProducts = new Map<number, boolean>()
      // we use '2020-01-01' as default date because time picker only uses time
      let defaultCheckInTime
      let defaultCheckOutTime
      ;({ defaultCheckInTime, defaultCheckOutTime } =
        this.getDefaultCheckTime(productActivity))

      let defaultHours: number[] = []

      if (defaultCheckInTime && defaultCheckOutTime) {
        if (
          moment(defaultCheckInTime).format('YYYY-MM-DD HH:mm') ==
          moment(defaultCheckOutTime).format('YYYY-MM-DD HH:mm')
        ) {
          defaultCheckInTime = moment(defaultCheckInTime).startOf('day')
          defaultCheckOutTime = moment(defaultCheckOutTime).endOf('day')
        }
        defaultHours = Array.from(
          {
            length: defaultCheckOutTime?.diff(defaultCheckInTime, 'hours') + 1
          },
          (_, i) => i + defaultCheckInTime?.hours()
        )
      }

      if (!productActivity?.parentBookableProducts) {
        console.error(
          `Product ${productActivity.description} has no parentBookableProducts`
        )
        continue
      }

      hiddenProducts = this.checkIfProductShouldHidden(
        productActivity,
        productEntities,
        selectedDate,
        defaultHours,
        productBookedHours,
        hiddenProducts
      )
      // //if product in Hidden Product dissable all hours
      // for (let [key, value] of hiddenProducts) {
      //   if (value == true) {
      //     productBookedHours.set(`${key}-${selectedDate.format()}`, [
      //       ...new Set([...defaultDisabledHours])
      //     ])
      //   }
      // }

      for (const productResourceId of productActivity?.parentBookableProducts) {
        const shouldHideResource = hiddenProducts.get(productResourceId)
        const bookableProduct = productEntities[productResourceId]
        const productKey = `${productResourceId}-${selectedDate.format()}`

        const productBookingsAtDate = bookings.filter(
          (booking) =>
            booking.productId === productResourceId &&
            selectedDate.isSameOrAfter(moment(booking.startDate), 'day') &&
            selectedDate.isSameOrBefore(moment(booking.endDate), 'day')
        )
        const totalProductsBookingsAtDate =
          productBookingsAtDate.length != 0
            ? productBookingsAtDate
            : this.bookedProductDuringStayWithDate.filter(
                (item) =>
                  item.productId == productResourceId &&
                  item.date == selectedDate
              )[0]?.booking
        const pfg = this.fb.group(
          {
            productId: [productActivity.id],
            bookableProductId: [productResourceId],
            //  qty: [null, [Validators.min(1)],
            qty: this.booking.details.participants.numberSleepOver
              ? [
                  null,
                  [
                    Validators.min(1),
                    Validators.max(
                      this.participationService.calculateParticipantLimits(
                        bookableProduct,
                        null,
                        null
                      ).maxParticipants
                    )
                  ]
                ]
              : [null, [Validators.min(1)]],
            checkIn: [defaultCheckInTime, []],
            checkOut: [defaultCheckOutTime, []],
            option: [null],
            note: [null],
            selected: [false],
            hideResource: [shouldHideResource],
            bookings: [totalProductsBookingsAtDate],
            bookedHours: [productBookedHours.get(productKey) ?? []],
            selectedDate: [selectedDate],

            maxParticipants: [
              this.participationService.calculateParticipantLimits(
                bookableProduct,
                null,
                null
              )
            ]
          },
          {
            validators: (formGroup: UntypedFormGroup) => {
              if (shouldHideResource) {
                return null
              }

              const checkInMoment = moment(formGroup.get('checkIn').value)
              const checkOutMoment = moment(formGroup.get('checkOut').value)

              const maxQty = formGroup.get('maxParticipants')?.value

              const isSelected = formGroup.get('selected').value === true
              const qty = formGroup.get('qty').value
              const isQtyRequired = isSelected && qty < 1

              const isCheckOutRequired =
                isSelected && !formGroup.get('checkOut').value
              let newCheckOutMoment = moment()
              newCheckOutMoment.set('hour', checkOutMoment.hour())
              newCheckOutMoment.set('minute', checkOutMoment.minute())
              let newCheckInMoment = moment()
              newCheckInMoment.set('hour', checkInMoment.hour())
              newCheckInMoment.set('minute', checkInMoment.minute())
              const isCheckOutBeforeCheckIn =
                isSelected &&
                !isCheckOutRequired &&
                newCheckOutMoment.isBefore(newCheckInMoment)

              const bookings = formGroup.get('bookings').value

              if (bookings?.length > 0 && isSelected) {
                const selectedDate: Moment = formGroup.get('selectedDate').value
                const isCurrentTimeOverlapBooking = bookings.some((booking) => {
                  const bookingStartTime = moment(booking.startDate)
                  const bookingEndTime = moment(booking.endDate)

                  const selectedCheckIn = selectedDate.clone().set({
                    hour: checkInMoment.hour(),
                    minute: checkInMoment.minute()
                  })

                  const selectedCheckout = selectedDate.clone().set({
                    hour: checkOutMoment.hour(),
                    minute: checkOutMoment.minute()
                  })

                  // Check if intervals overlap using moment
                  // Two intervals overlap if one starts before the other ends and vice versa
                  return (
                    bookingStartTime.isBefore(selectedCheckout) &&
                    bookingEndTime.isAfter(selectedCheckIn)
                  )
                })

                if (isCurrentTimeOverlapBooking) {
                  return {
                    overlapBooking: true
                  }
                }
              }
              if (typeof maxQty == 'object') {
                if (isSelected && qty > maxQty.maxParticipants) {
                  return {
                    maxParticipants: true
                  }
                }
              } else {
                if (isSelected && qty > maxQty) {
                  return {
                    maxParticipants: true
                  }
                }
              }
              const returnvalue =
                isQtyRequired || isCheckOutRequired || isCheckOutBeforeCheckIn
                  ? {
                      qtyRequired: isQtyRequired,
                      checkOutError:
                        isCheckOutRequired || isCheckOutBeforeCheckIn
                    }
                  : null
              return returnvalue
            }
          }
        )

        const productsHidden = this.totalHiddenProducts.get(
          `${pfg.controls['productId'].value}-${moment(selectedDate).format(
            'YYYY-MM-DD'
          )}`
        )
        if (!productsHidden) {
          productsFormArray.push(pfg)
        } else {
          if (!productsHidden.includes(productResourceId)) {
            productsFormArray.push(pfg)
          }
        }
      }
    }

    this.datesForm.push(fg)
  }
  public checkQty(qty, bookableProductId, productId, selectedDate) {
    if (qty <= 0 || !qty) {
      return
    }
    for (const control of this.datesForm.controls as UntypedFormGroup[]) {
      if (
        moment(control.value['date']).format('YYYY-MM-DD') ===
        selectedDate?.format?.('YYYY-MM-DD')
      ) {
        const formArray: UntypedFormArray = control.controls[
          'products'
        ] as UntypedFormArray
        let totalQtyForbookableProductId = 0
        let selectedProduct
        for (const nestedControl of formArray.controls as UntypedFormGroup[]) {
          if (
            nestedControl.value['bookableProductId'] === bookableProductId &&
            nestedControl.value['productId'] == productId
          ) {
            selectedProduct = nestedControl.value
            break
          }
        }
        if (!selectedProduct?.selected) {
          return
        }
        for (const nestedControl of formArray.controls as UntypedFormGroup[]) {
          if (
            nestedControl.value['bookableProductId'] === bookableProductId &&
            nestedControl.value['selected']
          ) {
            totalQtyForbookableProductId += nestedControl.value['qty'] ?? 0
          }
        }
        if (typeof selectedProduct.maxParticipants == 'object') {
          if (
            selectedProduct.selected &&
            totalQtyForbookableProductId >
              selectedProduct.maxParticipants.maxParticipants
          ) {
            control.setErrors({ qtyError: 'true' })

            this.translate
              .get('general.errorMaxParticipantsProduct')
              .pipe(take(1), withLatestFrom(this.productEntities$))
              .subscribe(([msg, productEntities]) => {
                this.notificationService.emit(
                  `${msg} ${
                    productEntities[selectedProduct.bookableProductId]
                      .description
                  }
               `,
                  'error'
                )
              })
            break
          }
        } else {
          if (
            selectedProduct.selected &&
            totalQtyForbookableProductId > selectedProduct.maxParticipants
          ) {
            control.setErrors({ qtyError: 'true' })

            this.translate
              .get('general.errorMaxParticipantsProduct')
              .pipe(take(1), withLatestFrom(this.productEntities$))
              .subscribe(([msg, productEntities]) => {
                this.notificationService.emit(
                  `${msg} ${
                    productEntities[selectedProduct.bookableProductId]
                      .description
                  }
               `,
                  'error'
                )
              })
            break
          }
        }
      }
    }
  }
  public hideBookableProduct(
    bookableProductId: number,
    datesList,
    productEntities?
  ): boolean {
    return !productEntities[bookableProductId].isActive
  }
  isFullhidden(product: Product, datesList, productEntities) {
    let productsHidden = 0
    let productsInactive = 0
    const hiddenProducts = this.totalHiddenProducts.get(
      `${product.id}-${datesList.format('YYYY-MM-DD')}`
    )
    product.parentBookableProducts.map((item) => {
      if (hiddenProducts && hiddenProducts.includes(item)) {
        productsHidden += 1
      }
      if (!productEntities[item].isActive) {
        productsInactive += 1
      }
    })
    return (
      productsHidden == product.parentBookableProducts.length ||
      product.parentBookableProducts.length == productsInactive
    )
  }
  isUnAvailableOrPartialAvailable(
    bookableProductId,
    product,
    datesList,
    formValues
  ) {
    const productKey = `${product.id}-${datesList.format()}`

    let defaultCheckInTime
    let defaultCheckOutTime
    ;({ defaultCheckInTime, defaultCheckOutTime } =
      this.getDefaultCheckTime(product))
    let defaultHoursActiv: number[] = []

    if (defaultCheckInTime && defaultCheckOutTime) {
      if (
        moment(defaultCheckInTime).format('YYYY-MM-DD HH:mm') ==
        moment(defaultCheckOutTime).format('YYYY-MM-DD HH:mm')
      ) {
        defaultCheckInTime = moment(defaultCheckInTime).startOf('day')
        defaultCheckOutTime = moment(defaultCheckOutTime).endOf('day')
      }
      defaultHoursActiv = Array.from(
        {
          length: defaultCheckOutTime?.diff(defaultCheckInTime, 'hours') + 1
        },
        (_, i) => i + defaultCheckInTime?.hours()
      )
    }

    const booked = this.bookedProductDuringStay.get(productKey)
      ? this.bookedProductDuringStay.get(productKey)
      : false
    if (!booked && formValues?.value?.bookedHours?.length > 0) {
      const hoursMatch = defaultHoursActiv.every((hour) =>
        formValues?.value?.bookedHours.includes(hour)
      )
      return !hoursMatch
    }
    return booked
  }
  isHidden(bookableProductId, product, datesList) {
    const hiddenProducts = this.totalHiddenProducts.get(
      `${product.id}-${datesList.format('YYYY-MM-DD')}`
    )

    return hiddenProducts ? hiddenProducts.includes(bookableProductId) : false
  }
  onDateClick(date, index) {
    this.selectedDateIndex = index
    this.selectedDate = date
  }
  public isProductBookedDuringStayWithDate(productId) {
    return (
      this.bookedProductDuringStayWithDate.filter(
        (bk) => bk.productId === productId
      ).length > 0
    )
  }
  public showProduct(product, selectedDate) {
    let totalProducts: number = 0
    if (!product?.parentBookableProducts) {
      return false
    }
    if (product?.parentBookableProducts?.length > 0) {
      this.totalHiddenProducts
        .get(`${product.id}-${selectedDate.format('YYYY-MM-DD')}`)
        ?.map((pr) => {
          if (product?.parentBookableProducts.includes(pr)) {
            totalProducts++
          }
        })
    }

    return !(
      !(totalProducts == product?.parentBookableProducts?.length) &&
      this.checkIfshouldBeHIddenInThisDate(product, selectedDate)
    )
  }
  public checkIfshouldBeHIddenInThisDate(
    product: Partial<Product>,
    selectedDate
  ) {
    return (
      (!!product.visibleFromDate &&
        !!product.visibleTillDate &&
        !(
          moment(selectedDate)
            .startOf('day')
            .set('seconds', 0)
            .isSameOrAfter(moment(product.visibleFromDate).set('seconds', 0)) &&
          moment(selectedDate)
            .endOf('day')
            .isSameOrBefore(moment(product.visibleTillDate).set('seconds', 0))
        )) ||
      (!!product.visibleFromDate &&
        (!product.visibleTillDate ||
          !moment(product.visibleTillDate).isValid()) &&
        !moment(product.visibleFromDate)
          .set('seconds', 0)
          .isSameOrBefore(
            moment(selectedDate).startOf('day').set('seconds', 0)
          )) ||
      (!!product.visibleTillDate &&
        (!product.visibleFromDate ||
          !moment(product.visibleFromDate).isValid()) &&
        !moment(product.visibleTillDate)
          .set('seconds', 0)
          .isSameOrAfter(moment(selectedDate).endOf('day').set('seconds', 0)))
    )
  }
}
